import styled from "styled-components"

import InputField from "~/components/InputField"

export const Section = styled.div`
	width: 100%;
	max-width: 550px;
	border: 1px solid var(--color-component-border);
	border-radius: 24px;
	background: var(--color-component-background);
	padding: 24px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
`

export const SectionTitle = styled.h3`
	font-weight: 600;
	font-size: 20px;
`

export const StyledInputField = styled(InputField)`
	width: 100%;
`
